import type { Event, EventTemplate, VerifiedEvent } from 'nostr-tools/core';
import { verifyEvent } from 'nostr-tools/pure';

export function requireExactSignerResult(template: EventTemplate, signed: Event, expectedPubkey: string): VerifiedEvent {
  if (!verifyEvent(signed)) throw new Error('The signer returned an invalid signature.');
  if (signed.pubkey !== expectedPubkey) throw new Error('The signer returned an event from another identity.');
  if (
    signed.kind !== template.kind ||
    signed.created_at !== template.created_at ||
    signed.content !== template.content ||
    !sameTags(signed.tags, template.tags)
  ) {
    throw new Error('The signer changed the event after you reviewed it. Nothing was published.');
  }
  return signed as VerifiedEvent;
}

function sameTags(left: string[][], right: string[][]): boolean {
  if (left.length !== right.length) return false;
  return left.every((tag, index) => {
    const expected = right[index];
    return tag.length === expected.length && tag.every((value, valueIndex) => value === expected[valueIndex]);
  });
}
